package com.arena_web.domain.repositories

import com.arena_web.data.dto.*

interface ChatRepository {
    // Chat CRUD
    suspend fun createDirectChat(request: CreateDirectChatRequest): Result<ChatDto>
    suspend fun createGroupChat(request: CreateGroupChatRequest): Result<ChatDto>
    suspend fun getChats(params: Map<String, String> = emptyMap()): Result<ChatListPageDto>
    suspend fun getChat(chatId: String): Result<ChatDto>
    suspend fun updateGroupChat(chatId: String, request: UpdateGroupChatRequest): Result<ChatDto>
    suspend fun uploadChatImage(chatId: String, fileBytes: ByteArray, fileName: String, contentType: String): Result<ImageUploadResponse>
    suspend fun leaveChat(chatId: String): Result<Unit>

    // Messages
    suspend fun getMessages(chatId: String, params: Map<String, String> = emptyMap()): Result<MessagesPageDto>
    suspend fun sendMessage(chatId: String, request: SendMessageRequest): Result<MessageDto>
    suspend fun markAsRead(chatId: String): Result<Unit>
    suspend fun deleteMessage(chatId: String, messageId: String): Result<Unit>
    suspend fun editMessage(chatId: String, messageId: String, request: EditMessageRequest): Result<MessageDto>
    suspend fun sendMediaMessage(chatId: String, fileBytes: ByteArray, fileName: String, fileContentType: String, duration: Int? = null): Result<MessageDto>

    // Reactions
    suspend fun addReaction(chatId: String, messageId: String, request: AddReactionRequest): Result<Unit>
    suspend fun removeReaction(chatId: String, messageId: String, emoji: String): Result<Unit>

    // Pin
    suspend fun togglePin(chatId: String, messageId: String): Result<MessageDto>
    suspend fun getPinnedMessages(chatId: String): Result<List<MessageDto>>

    // Forward & Search
    suspend fun forwardMessage(chatId: String, messageId: String, request: ForwardMessageRequest): Result<MessageDto>
    suspend fun searchMessages(chatId: String, params: Map<String, String>): Result<MessagesPageDto>

    // Members
    suspend fun kickMember(chatId: String, userId: String): Result<Unit>

    // Invitations
    suspend fun inviteToChat(chatId: String, request: InviteToChatRequest): Result<Unit>
    suspend fun getInvitations(): Result<List<ChatInvitationDto>>
    suspend fun respondToInvitation(invitationId: String, request: RespondToInvitationRequest): Result<Unit>

    // Join requests
    suspend fun joinChat(chatId: String): Result<Unit>
    suspend fun getJoinRequests(chatId: String): Result<List<ChatJoinRequestDto>>
    suspend fun respondToJoinRequest(chatId: String, requestId: String, request: RespondToJoinRequestRequest): Result<Unit>

    // Mute & Online
    suspend fun muteChat(chatId: String, request: MuteChatRequest): Result<Unit>
    suspend fun getOnlineUsers(chatId: String): Result<Set<String>>
}
